import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ke2sd5y4v: FaireProductEntity = {
  token: "p_7ke2sd5y4v",
  type: "product",
  name: "Wild Herb Tonic– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/186c4de23ff8cda58b2db1b1e1ed745de25a493241c4f43fa2b2b54211ca4b15.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef75d9fa3fb57b4a3b15306a08c4ea4d5f1b2c72f69a6f66d0bbb3e263db8ea4.jpeg",
    "https://cdn.faire.com/fastly/fee5dddadd87733ab7b11c51c6e929bc14e0dfa960b27192b0464b6ed5877035.jpeg",
    "https://cdn.faire.com/fastly/dbda7a6e7a501e059ef8f315e7bc57e7e7fd7fb2f9014068c01dbec5c210745c.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Barefoot walks through wild herb gardens, cool mountain stream baths, crisp morning air. Lemon balm, thyme, orange, fir.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:54.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
